import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import HighchartsReact from 'highcharts-react-official';
import configurationManagementService from '@services/configuationManagement.service';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import jwt_decode from 'jwt-decode';

const ColumnChart = ({ data, dates }) => {
  const start =
    dates[0] !== null ? new Date(dates[0]).toLocaleDateString() : '';
  const end = dates[1] !== null ? new Date(dates[1]).toLocaleDateString() : '';
  const users = Object.keys(data).filter((user) => {
    return user !== 'Grand Total';
  });
  const technologies = Object.keys(data[users[0]])
    .filter((tech) => {
      return tech !== 'Total';
    })
    .sort((a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });
  console.log(technologies);
  const series = {};
  for (let tech of technologies) {
    if (!series[tech]) series[tech] = [];
    for (let user of users) {
      series[tech].push(data[user][tech]);
    }
  }

  const options = {
    chart: {
      type: 'column',
    },
    title: {
      text: `Done CRs Per User Per Technology from ${start} to ${end}`,
    },
    xAxis: {
      categories: users,
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Done CRs',
      },
    },
    series: Object.keys(series).map((tech) => ({
      name: tech,
      data: series[tech],
    })),
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y;
          },
        },
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

const TableData = ({ data }) => {
  const users = Object.keys(data);
  // .sort((a, b) => { })
  console.log('users', users);
  const tableValues = [];

  for (let user of users) {
    tableValues.push({
      User: user,
      ...data[user],
    });
  }
  return (
    <DataTable
      value={tableValues}
      tableStyle={{
        minWidth: '50rem',
      }}
    >
      {Object.keys(tableValues[0]).map((value) => (
        <Column field={value} header={value}></Column>
      ))}
    </DataTable>
  );
};

function CM_Dashboard() {
  const managementUsers = [
    'iman.f@mtnirancell.ir',
    'sirous.re@mtnirancell.ir',
    'farhad.gha@mtnirancell.ir',
    'farzam.e@mtnirancell.ir',
    'safiyeh.s@mtnirancell.ir',
    'testuser@test.com',
  ];
  const [data, setData] = useState({});
  const now = new Date();
  const one_week_earlier = new Date(
    new Date().getTime() - 7 * 24 * 60 * 60 * 1000
  );
  const [dates, setDates] = useState([one_week_earlier, now]);
  const token = jwt_decode(localStorage.getItem('plano-jwt'));
  const user =
    token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];

  async function fetcher() {
    try {
      const { data } = await configurationManagementService.Post(
        '/irancell/dashboard',
        { dates: dates }
      );
      setData(data);
    } catch (error) {
      console.log(error);
    }
  }
  function submit_button() {
    if (!dates.includes(null)) {
      fetcher();
    }
  }
  useEffect(() => {
    fetcher();
  }, []);
  return managementUsers.includes(user) ? (
    <div className="bg-white border border-gray-200 rounded-md p-5 grid grid-cols-10 gap-4">
      {/* <h1>CM Dashboard</h1> */}
      <Calendar
        className="col-span-2"
        placeholder="Select date for export"
        value={dates}
        onChange={(e) => setDates(e.value)}
        selectionMode="range"
        showIcon
        readOnlyInput
      />
      <Button
        className="col-span-1 justify-center text-xl"
        onClick={() => submit_button()}
      >
        Submit
      </Button>
      {Object.keys(data).length > 0 ? (
        <div className="col-span-10">
          <div className="col-span-10">
            <ColumnChart data={data} dates={dates} />
          </div>
          <div className="col-span-10">
            <TableData data={data} />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  ) : (
    <div>
      <h1>CM Dashboard</h1>
      <h1>Access Denied!</h1>
    </div>
  );
}
export default CM_Dashboard;
